import React, { useState } from "react";
import {
  Col,
  Container,
  Row,
  Button,
  Table,
  Modal,
  Form,
  InputGroup
} from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import { Link } from "react-router-dom";

import "../spot_styles/spotlower.css";

export default function AssetTable() {
  const [assetTab, setAssetTab] = useState(false);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <Container fluid className="p-lg-0 m-lg-0">
      <Row className="m-lg-0">
        <Col className="lower_spot_left_right">
          <div className="spot_lower_right">
            <div>
              <h6>Assets</h6>
            </div>
            <div>
              <Row>
                <Tab.Container
                  id="left-tabs-example"
                  defaultActiveKey="Deposit"
                >
                  <Row>
                    <Col className="asset_tabs">
                      <Nav
                        variant="pills"
                        className="mb-3 justify-content-between flex-nowrap asset_tabs"
                      >
                        <Nav.Item>
                          <Nav.Link
                            eventKey="Deposit"
                            className="asset_tab"
                          >
                            Deposit
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link>
                            <Link
                              to="/withdraw"
                              className="text-decoration-none assetTable_wdLink rounded"
                            >
                              Withdraw
                            </Link>
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="Transfer" className="asset_tab" onClick={handleShow}>
                            Transfer
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </Col>
                  </Row>

                  <Col className="ps-1">
                    <Tab.Content className="">
                      <Tab.Pane eventKey="Deposit" className="assetscroll">
                        <div className="px-2">
                          {Array(1)
                            .fill("")
                            .map((item, index) => {
                              return (
                                <>
                                  <div className="d-flex justify-content-between align-items-start me-auto asset_tab_data">
                                    <p>BTC Avbl：</p>
                                    <p>0.00000000{index}</p>
                                  </div>
                                </>
                              );
                            })}
                        </div>
                        <div className="px-2">
                          {Array(1)
                            .fill("")
                            .map((item, index) => {
                              return (
                                <>
                                  <div className="d-flex justify-content-between align-items-start me-auto asset_tab_data">
                                    <p>USDT Avbl：</p>
                                    <p>0.00000000{index}</p>
                                  </div>
                                </>
                              );
                            })}
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="Withdraw"></Tab.Pane>
                      <Tab.Pane eventKey="Transfer">
                        <Modal
                          show={show}
                          onHide={handleClose}
                          animation={false}
                          centered
                        >
                          <Modal.Header closeButton>
                            <Modal.Title>Transfer</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <span>VirtualEx internal transfers do not charge fees</span>
                            <div className="mt-3">
                              <span>From</span>
                            </div>
                            <Form.Select>
                              <option value="1">P2P Account</option>
                              <option value="1">USD-M Futures</option>
                            </Form.Select>
                            <div className="mt-3">
                              <span>To</span>
                            </div>
                            <Form.Control type="text" placeholder="Spot" disabled/>
                            <hr />
          <div className='d-flex justify-content-between'>
          <span>Amount</span>
          <span>0.000000000 USDT Available</span>
        </div>
        <InputGroup>
          <Form.Control type='text' />
          <InputGroup.Text id="basic-addon1">All</InputGroup.Text>
          </InputGroup>
          <div className='mt-3 text-center'>
            <Button variant="muted">Confirm</Button>
          </div>
                          </Modal.Body>
                        </Modal>
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Tab.Container>
              </Row>
            </div>

            <div className="lower_spot_left_right_table">
              <Table></Table>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
